/* istanbul ignore file */
import { IconButton as MaterialIconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

import { rem } from '../../theme';

import { StyledIconButtonProperties } from './PinoIconButton.types';

export const StyledPinoIconButton = styled(MaterialIconButton, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<StyledIconButtonProperties>`
    ${({ theme }) => `
        padding: ${theme.tggSpacing(rem(0.3), 1)};
        font-weight: 900;
        color: ${theme.palette.common.blue};
        text-transform: lowercase;
        background-color: ${theme.palette.common.white};
        
        &:hover {
            background-color: ${theme.palette.common.white};
        }
	`}

    ${({ disabled }: StyledIconButtonProperties) => {
        if (disabled) {
            return `
                opacity: 0.5;
                cursor: not-allowed;
            `;
        }

        return ``;
    }}

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        ${({ theme }) => theme.typography.text_14}
    }

    ${({
        selected,
        $buttonLocation: variant,
        theme,
    }: StyledIconButtonProperties) => {
        if (selected && variant === 'card') {
            return `
                background-color: ${theme.palette.common.blue};
                border-color: ${theme.palette.common.blue};
            `;
        }
        return selected ? `border-color: ${theme.palette.common.white}` : ``;
    }};
`;
